export const MALE = "male";

export const FEMALE = "female";
